import { alpha } from '@/styles/shared';
interface CopyIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const CopyIcon = ({ 
  width = 16, 
  height = 19, 
  fill = alpha.purple60
}: CopyIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 19" fill="none">
      <path
        d="M10.4 0H2.4C1.76348 0 1.15303 0.252856 0.703592 0.702304C0.254144 1.15175 0.00128746 1.76218 0.00128746 2.39871V13.5935H2.4V2.39871H10.4V0ZM12.8 4.79742H5.6C4.96348 4.79742 4.35303 5.05028 3.90358 5.49972C3.45414 5.94917 3.20128 6.5596 3.20128 7.19613V16.7923C3.20128 17.4288 3.45414 18.0392 3.90358 18.4887C4.35303 18.9381 4.96348 19.191 5.6 19.191H12.8C13.4365 19.191 14.047 18.9381 14.4964 18.4887C14.9459 18.0392 15.1987 17.4288 15.1987 16.7923V7.19613C15.1987 6.5596 14.9459 5.94917 14.4964 5.49972C14.047 5.05028 13.4365 4.79742 12.8 4.79742Z"
        fill={fill}
      />
    </svg>
  );
};

export default CopyIcon;
